export default "__VITE_ASSET__DbEugXyH__"